import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="cctv--notification"
export default class extends Controller {
  static targets = ['input', 'form']

  connect() {
  }


  async toggleNotification(){
    let formElement = this.formTarget;
    let actionUrl = formElement.action;
    let data_form = new FormData(formElement);
    let params = Object.fromEntries(data_form.entries());
    await fetch(actionUrl, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      responseKind: 'json',
      body: JSON.stringify(params)
    });


  }

}
